// !! AUTOGENERATED, DO NOT EDIT !!
// See 'scripts/generate-icons.js'

// If you want to add an icon, place the svg in 'src/assets/icons',
// then run 'pnpm run generate:icons'. Make sure the icon file name
// follows the pattern camelCase.svg

// If you want to remove an icon, remove the svg from 'src/assets/icons',
// then run 'pnpm run generate:icons'.
import React from 'react';

import { ReactComponent as CreditsIconSvg } from '../../assets/icons/credits.svg';

import { IconProps } from './types';
import IconWrapper from './Wrappers/IconWrapper';

const CreditsIcon: React.FC<IconProps> = (props) => {
  return (
    <IconWrapper {...props}>
      <CreditsIconSvg />
    </IconWrapper>
  );
};

export default CreditsIcon;
